import { Box, Table, TableBody, TableHead, TableRow } from "@mui/material";
import { ReadonlyVec3 } from "gl-matrix";
import { useTranslation } from "react-i18next";

import { useUom } from "features/uom/hooks/useUom";
import { UnitType } from "features/uom/spec";
import { convertAndFormat } from "features/uom/utils";

import { TableCell } from "./tableCell";

export function VertexTable({ vertices, text }: { vertices: ReadonlyVec3[]; text?: string[] }) {
    const { t } = useTranslation();
    const uom = useUom();

    return (
        <Table size="small" padding="none">
            <TableHead>
                <TableRow>
                    <TableCell></TableCell>
                    <TableCell align="center">
                        <Box display="inline-block" ml={1}>
                            X
                        </Box>
                    </TableCell>
                    <TableCell align="center">
                        <Box display="inline-block" ml={1}>
                            Y
                        </Box>
                    </TableCell>
                    <TableCell align="center">
                        <Box display="inline-block" ml={1}>
                            Z
                        </Box>
                    </TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {vertices.map((p, i) => (
                    <TableRow key={i}>
                        <TableCell> {text && text.length > i ? text[i] : t("vertex")}</TableCell>
                        {p.map((v, idx) => (
                            <TableCell key={idx} align="right">
                                {convertAndFormat(uom, v, UnitType.length, { decimals: 3 })}
                            </TableCell>
                        ))}
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    );
}
